import {
    SALES_BY_REGION_HEATMAP_SUCCESS,
    TOP_LOCATION_SALES_LOADING,
    TOP_PRODUCT_SALES_LOADING,
    TOP_CATEGORY_SALES_SUCCESS,
    TOP_LOCATION_SALES_SUCCESS,
    SALES_BY_REGION_HEATMAP_LOADING

} from '../actions/SalesByRegionAction';

const initialState = {
    salesByRegionHeatmapData: null,
    topLocationSalesData: null,
    topCategorySalesData: null,
    isLoading: true,
    isTopLocationsLoading: true,
    isTopProductLoading: true
};

const SalesByRegion = (state = initialState, action = {}) => {
    switch (action.type) {
        case SALES_BY_REGION_HEATMAP_SUCCESS:
            return { ...state, salesByRegionHeatmapData: action.data, isLoading: false };
        case TOP_CATEGORY_SALES_SUCCESS:
            return { ...state, topCategorySalesData: action.data, isTopProductLoading: false };
        case TOP_LOCATION_SALES_SUCCESS:
            return { ...state, topLocationSalesData: action.data, isTopLocationsLoading: false };
        case SALES_BY_REGION_HEATMAP_LOADING:
            return { ...state, isLoading: action.isLoading };
        case TOP_PRODUCT_SALES_LOADING:
            return { ...state, isTopProductLoading: action.isTopProductLoading };
        case TOP_LOCATION_SALES_LOADING:
            return { ...state, isTopLocationsLoading: action.isTopLocationsLoading };

        default:
            return state;
    }
};

export default SalesByRegion;
